import eventMixin from '../lib/eventMixin';
import KeenSlider from 'keen-slider';
import Logger from '../utilities/Logger';
import ThemeMediaLightbox from '../partials/themeMediaLightbox';

const paginationDotActiveClass = 'theme-media-panel__slideshow-pagination-dot--active';

export default class ThemeMediaPanel {

	constructor(dom) {

		Logger.info('ThemeMediaPanel: initializing...');

		var self = this;

		this.dom = dom;

		this.isInitialized = false;

		// Boostrap a slideshow (if necessary)
		this.pagination = this.dom.querySelector('[data-theme-media-panel-slideshow-pagination]');
		this.paginationDots = this.dom.querySelectorAll('[data-theme-media-panel-slideshow-slide-show]');
		this.slides = null;
		this.slideshow = null;
		this.slideshowElement = this.dom.querySelector('[data-theme-media-panel-slideshow]');
		if (this.slideshowElement) {
			this.slides = this.dom.querySelectorAll('[data-theme-media-panel-slide]');
		}

		// Listen for a focused event, and then initialize
		// the slideshow (once)
		self.on('focused', () => {
			self.init();
		});

		// Create an Observer
		// We only want to initialize the slider when it's actually visible
		// on the page.
		this.observer = new IntersectionObserver((entries) => {

			// Check for the intersecting item
			entries.forEach((entry, index) => {
				if (entry.isIntersecting) {

					entry.target.setAttribute('data-is-visible', true);
					Logger.info('ThemeMediaPanel: focused...');
					self.trigger("focused", entry.target);

				} else {

					entry.target.removeAttribute('data-is-visible', true);
					Logger.info('ThemeMediaPanel: blurred...');
					self.trigger("blurred", entry.target);

				}

			});

			this.trigger("updated");

		}, {
			threshold: .01,
		});

		this.observer.observe(this.dom);
	}

	init() {

		const self = this;

		if (this.isInitialized) {
			return;
		}

		// Set up the slideshow
		if (self.slideshowElement && self.slides && !self.slideshow) {
			// self.slideshow = new KeenSlider(self.dom, {
			// 	selector: self.slides,
			// 	loop: true,
			//   created: () => {
			//      Logger.info('ThemeMediaPanel: created...');
			//      self.trigger('created');

			//      // We have to wait a bit because the this.slideshow var is not
			//      // immediately available since we are in the created event still
			//      setTimeout(() => {
			//       self.adjustSlideshowClasses();
			//      },100);
			//    },
			//    destroyed: () => {
			//      Logger.info('ThemeMediaPanel: destroyed...');
			//    	self.trigger('destroyed');
			//    },
			// 	slideChanged: () => {
			//      Logger.info('ThemeMediaPanel: slideChanged...');
			//      self.adjustSlideshowClasses();
			// 	},
			// });

			// Initialize pagination dots
			// this.paginationDots.forEach((dot) => {
			// 	dot.addEventListener('click', (e) => {
			// 		const idx = dot.getAttribute('data-theme-media-panel-slideshow-slide-show');
			// 		Logger.info(`Pagination dot was clicked, adjusting slideshow to slide ${idx}`);
			// 		self.slideshow.moveToIdx(idx * 1);
			// 	});
			// });

			self.slideshowElement.addEventListener('click', (e) => {

				const items = self.slideshowElement.getAttribute('data-theme-media-panel-slideshow');
				const mediaItems = items.split(',');

				Logger.info(`Opening Lightbox: ${items}`);

				const openEvent = new CustomEvent(ThemeMediaLightbox.events.open, {
					detail: {
						mediaItems: mediaItems.map((item) => {
							const parts = item.split('|');
							return parts[0] == 'image' ? { type: 'image', src: parts[1] } : { type: 'vimeo', id: parts[1] };
						})
					},
					bubbles: true,
					cancelable: true,
					composed: false,
				});
				document.dispatchEvent(openEvent);
			});
		}

		// Handle any actions to open a video
		const videoOpenActionElement = this.dom.querySelector('[data-theme-media-panel-video-open-action]');
		if (videoOpenActionElement) {
			videoOpenActionElement.addEventListener('click', (e) => {

				const vimeoId = videoOpenActionElement.getAttribute('data-theme-media-panel-video-open-action');

				if (vimeoId) {

					Logger.info(`Opening Vimeo ID: ${vimeoId}`);

					const openEvent = new CustomEvent(ThemeMediaLightbox.events.open, {
						detail: {
							mediaItems: [{
								type: 'vimeo',
								id: vimeoId
							}]
						},
						bubbles: true,
						cancelable: true,
						composed: false,
					});
					document.dispatchEvent(openEvent);

				} else {
					console.error('No Vimeo ID was provided. Aborting modal...');
				}

			});
		}

		this.isInitialized = true;
	}

	adjustSlideshowClasses() {
		const activeSlide = this.slideshow.track.details.rel;

		if (this.paginationDots && this.paginationDots[activeSlide]) {
			this.paginationDots.forEach((dot) => {
				dot.classList.remove(paginationDotActiveClass);
				dot.setAttribute('aria-selected', 'false');
			});
			this.paginationDots[activeSlide].classList.add(paginationDotActiveClass);
			this.paginationDots[activeSlide].setAttribute('aria-selected', 'true');
		}
	}

}

// Mixins
Object.assign(ThemeMediaPanel.prototype, eventMixin);
